import { Button, P, Section } from '@ahmdigital/ui';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  margin-top: 1.5rem;
  min-width: 20rem;
  @media (min-width: ${({ theme }) => theme.media.md}) {
    margin-top: 7rem;
  }
`;

export const StyledP = styled(P)`
  margin-bottom: 2rem;
  @media (min-width: ${({ theme }) => theme.media.md}) {
    margin-bottom: 5.5rem;
  }
`;

export const StyledSection = styled(Section)`
  padding-left: 1rem;
  padding-right: 1rem;
  text-align: center;
`;

export const ImageWrapper = styled.div`
  margin: '0 auto';
  max-width: '31.25rem';
`;
